export default {
    getObject(key) {
        return localStorage.getItem(key)
    },

    setObject(key, value) {
        localStorage.setItem(key, JSON.stringify(value))
    },

    destroyObject(key) {
        window.localStorage.removeItem(key)
    },

    updateItem(key, property, value) {
        var obj = this.getObject(key);
        obj = JSON.parse(obj)
        obj[property] = value;
        this.setObject(key, obj);
        return obj;
    }
}
